import React from "react";
import { useNavigate } from "react-router-dom";
import { PublicShell } from "@/components/shared";
import { Button } from "@/components/ui/button";

const SECTORS = ["Jewellery manufacturing & export", "Consumer products", "Digital businesses"];

export default function About() {
  const navigate = useNavigate();
  return (
    <PublicShell>
      <section className="border-b border-rule">
        <div className="mx-auto max-w-[1040px] px-5 py-16 lg:px-8">
          <p className="kicker text-xs text-brass">About</p>
          <h1 className="mt-4 font-heading text-4xl font-bold text-ink sm:text-5xl">Entrepreneur to entrepreneur.</h1>
          <p className="mt-6 max-w-2xl text-lg text-bodytext">
            I'm not a trainer and I don't teach theory. I run businesses, and I teach the things I've had to figure out running them — in plain language, with real examples, and tools you can put to work the same week.
          </p>
        </div>
      </section>

      <section className="border-b border-rule">
        <div className="mx-auto flex max-w-[1040px] flex-col px-5 py-16 lg:flex-row lg:px-8">
          <div className="mb-4 lg:w-[140px] lg:flex-shrink-0"><span className="kicker text-xs text-brass">01</span><span className="kicker ml-3 text-xs text-mutedink lg:ml-0 lg:mt-1 lg:block">Where I work</span></div>
          <div className="flex-1 space-y-4 text-bodytext">
            <p>I've built and run businesses across three worlds: a decades-old family jewellery manufacturing and export house (Shree Taru Jewels), a consumer products brand sold across marketplaces, quick commerce and a physical retail floor (NEWDRU), and a set of digital products I'm building now, run mostly with AI (Siyaara).</p>
            <p>That mix is the point. The problems rhyme — a distributor who won't reorder, a price increase that won't stick, a team doing by hand what a system should do, a number you don't have when you need it. I've hit all of them, in more than one sector, and that's what I bring to the room.</p>
            <p>I was recognised by GJEPC as one of their 40 Under 40. But the credential that matters here is simpler: everything I teach, I'm still doing this week.</p>
            <div className="flex flex-wrap gap-2 pt-2">
              {SECTORS.map((s) => <span key={s} className="kicker rounded-[3px] border border-rule px-3 py-1 text-xs text-mutedink">{s}</span>)}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto flex max-w-[1040px] flex-col px-5 py-16 lg:flex-row lg:px-8">
          <div className="mb-4 lg:w-[140px] lg:flex-shrink-0"><span className="kicker text-xs text-brass">02</span><span className="kicker ml-3 text-xs text-mutedink lg:ml-0 lg:mt-1 lg:block">How I teach</span></div>
          <div className="flex-1">
            <p className="max-w-2xl text-bodytext">Simple explanations, real examples, and tools you can use the same week. No jargon, no funnels, no theory you'll never apply. If it hasn't earned its place in one of my own businesses, I don't teach it.</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button onClick={() => navigate("/apply")} data-testid="about-apply-btn" className="rounded-[3px] bg-brass px-6 py-3 text-paper hover:opacity-90">Apply for the next cohort</Button>
              <Button onClick={() => navigate("/blog")} data-testid="about-daily-btn" variant="outline" className="rounded-[3px] border-[1.5px] border-ink bg-transparent px-6 py-3 text-ink hover:bg-ink hover:text-paper">Read the daily</Button>
            </div>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
